import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { wrapper, svgContainer } from "./ProgressRing.css.mjs";
import { vars } from "../../../themes/vars.css.mjs";
const ProgressRing = ({
  radius,
  stroke,
  progress: initialProgress,
  children
}) => {
  const progress = !isNaN(initialProgress) ? initialProgress : 0;
  const strokeOffset = stroke * 2;
  const normalizedRadius = radius - strokeOffset;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - progress / 100 * circumference;
  return /* @__PURE__ */ jsxs(Box, { className: wrapper, children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        position: "absolute",
        top: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        style: { height: radius * 2 - strokeOffset, width: radius * 2 - strokeOffset },
        children
      }
    ),
    /* @__PURE__ */ jsxs(
      "svg",
      {
        height: radius * 2 - strokeOffset,
        width: radius * 2 - strokeOffset,
        className: svgContainer,
        children: [
          /* @__PURE__ */ jsx(
            "circle",
            {
              stroke: vars.borderColor.neutralLight,
              fill: "transparent",
              strokeWidth: stroke,
              r: normalizedRadius,
              cx: radius - stroke,
              cy: radius - stroke
            }
          ),
          /* @__PURE__ */ jsx(
            "circle",
            {
              stroke: vars.borderColor.formAccent,
              fill: "transparent",
              strokeWidth: stroke,
              strokeDasharray: `${circumference} ${circumference}`,
              style: { strokeDashoffset },
              r: normalizedRadius,
              cx: radius - stroke,
              cy: radius - stroke
            }
          )
        ]
      }
    )
  ] });
};
export {
  ProgressRing
};
